import styled from 'styled-components';
import Dialog from '@components/2-molecules/Dialog';

/**
 * The Dialog molecule's default inner width is 600px — too wide for the
 * compact skip confirmation. Clamp to 28rem (448px) by targeting the only
 * direct child (`InnerWrapper`) without forking the shared component.
 */
export const NarrowDialog = styled(Dialog)`
  > * {
    width: min(calc(100% - 32px), 28rem) !important;
  }
`;
